import { memberDisplayNameToProfileSlug } from '../../../../src/components/GovTrades/memberProfileSlug';
import { formatTickerToURLFriendly } from '@benzinga/utils';

export const securityHref = (ticker?: string | null) =>
  ticker ? `/government-trades/securities/${formatTickerToURLFriendly(ticker)}` : undefined;

export const memberHref = (displayName?: string | null) => {
  const slug = memberDisplayNameToProfileSlug(displayName);
  return slug ? `/government-trades/members/${slug}` : undefined;
};
